const GLOBAL_QUERY_KEYS = {
  MAP: {
    telematics: ["map", "telematics"],
    TELEMATICS_MACHINES: ["map", "telematics", "machines"],
    TELEMATICS_MACHINE_GROUPS: ["map", "telematics", "machine-groups"],
    TELEMATICS_DRIVERS: ["map", "telematics", "drivers"],
    TELEMATICS_POSITIONS: ["map", "telematics", "positions"],
    TELEMATICS_HISTORY: ["map", "telematics", "history"],
    TELEMATICS_DASHBOARD: ["map", "telematics", "dashboard"],
  },
  PRECISION_FARMING: {
    root: {
      ALL: ["precision-farming"],
      INTEGRATIONS: ["precision-farming", "integrations"],
      PARCEL: ["precision-farming", "parcel"],
      REPORTS: ["precision-farming", "reports"],
    },
    NITROGEN: ["precision-farming", "parcel", "nitrogen"],
    DASHBOARD: ["precision-farming", "dashboard"],
    PF_VERSION: ["precision-farming", "pf-version"],
    SERVICES: ["precision-farming", "services"],
    YIELD_MAPS: ["precision-farming", "yield-maps"],
    SERVICE_GUARD: ["precision-farming", "service-guard"],
    PARCEL_IMPORT: ["precision-farming", "parcel-import"],
    PRESCRIPTION_MAPS: ["precision-farming", "prescription-map"],
    FILE_STORAGE: ["precision-farming", "file-storage"],
  },
  CATALOGUES: {
    SHARED: ["catalogues"],
    CROPS: ["catalogues", "crops"],
    CROP_GROUPS: ["catalogues", "crops", "crop-groups"],
    SEEDS: ["catalogues", "seeds"],
    FERTILIZERS: ["catalogues", "fertilizers"],
    PLANT_PROTECTION: ["catalogues", "plantProtection"],
    PRODUCTION_OPERATIONS: ["catalogues", "production-operations"],
    MACHINES: ["catalogues", "machines"],
    MACHINE_GROUPS: ["catalogues", "machine-groups"],
    MACHINE_CATEGORIES: ["catalogues", "machine-categories"],
    DRIVERS: ["catalogues", "drivers"],
    EQUIPMENT: ["catalogues", "equipment"],
    FACILITIES: ["catalogues", "facilities"],
  },
  TELEMATICS: {
    ACTION_DRIVES: ["telematics", "action-drives"],
    MACHINES: ["telematics", "machines"],
    LOGBOOK: ["telematics", "logbook"],
    ADVANCED_FILTER: ["telematics", "advanced-filter"],
    DRIVE_KEY: ["telematics", "keys"],
    WINFAS_CLIENT: ["telematics", "winfas", "clients"],
    DRIVERS: ["telematics", "drivers"],
    DRIVERS_DASHBOARD: ["telematics", "drivers-dashboard"],
    RULES: ["telematics", "rules"],
    HANDWORK: ["telematics", "handwork"],
    IMPORT_HISTORY: ["telematics", "import-history"],
    CUSTOMER_KEY_CALCULATION: ["telematics", "customer-key-calculation"],
    RELATED_DRIVES: ["telematics", "related-drives"],
    SEED_APPLICATIONS: ["telematics", "seed-applications"],
  },
  ADMIN: {
    MANAGER: {
      FARMS: ["admin", "manager", "farms"],
      SENTINEL: ["admin", "manager", "sentinel"],
      TELEMATICS: ["admin", "manager", "telematics"],
      TELEMATICS_COUNTRIES: ["admin", "manager", "telematics-countries"],
    },
    IMPERSONATION: ["admin", "impersonation", "all-farms"],
  },
  CORE: {
    PRECISION: {
      DETAIL: ["core", "precision", "detail"],
      BIOMONITORING: ["core", "precision", "biomonitoring"],
      SOIL_SAMPLES: ["core", "precision", "soil-samples"],
      YIELD_MAPS: ["core", "precision", "yield-maps"],
    },
    USER: {
      INTEGRATIONS: ["core", "user", "integrations"],
    },
  },
  SENSORS: {
    ALL: ["sensors"],
    LOCATIONS: ["sensors", "locations"],
    GROUPS: ["sensors", "groups"],
  },
  IRRIGATION: {
    AREAS: ["irrigation", "areas"],
    DEVICES: ["irrigation", "devices"],
  },
  VARIABLE_APPLICATIONS: {
    ACTIONS: ["variable-applications", "actions"],
    BY_ACTION: ["variable-applications", "by-action"],
  },
  SOWING_PLAN_V2: ["sowing-plan-v2"],
  STORES: ["stores"],
  REPORTS: ["reports"],
  REPORTS_HISTORY: ["reports", "history"],
  SHARED: {
    AGROEVIDENCE: {
      SEED_APPLICATIONS: ["shared", "agroevidence", "seed-aplications"],
      SUBTRACTABLE_AREAS: ["shared", "agroevidence", "vegetation-strips"],
    },
  },
};

export { GLOBAL_QUERY_KEYS };
